import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowRight } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="container py-12">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo.png" alt="" className="h-12 w-auto" />
              <span className="font-display text-xl font-bold text-foreground/80">
                WanderDaddy
              </span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Join our community to find the best local spots, hidden gems, and authentic experiences with WanderDaddy.
            </p>
            <div className="flex gap-2">
              <Input
                type="email"
                placeholder="Enter your email"
                className="max-w-[200px]"
              />
              <Button size="icon" className="shrink-0" aria-label="Subscribe">
                <ArrowRight className="h-4 w-4" />
              </Button>
            </div>
          </div>

          {/* Company */}
          <div className="space-y-4">
            <h2 className="text-base font-semibold text-foreground">Company</h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/about" className="hover:text-primary">About Us</Link></li>
              <li><Link to="/careers" className="hover:text-primary">Careers</Link></li>
              <li><Link to="/press" className="hover:text-primary">Press</Link></li>
              <li><Link to="/stories" className="hover:text-primary">Stories</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h2 className="text-base font-semibold text-foreground">Support</h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/help" className="hover:text-primary">Help Center</Link></li>
              <li><Link to="/safety" className="hover:text-primary">Safety Information</Link></li>
              <li><Link to="/cancellation" className="hover:text-primary">Cancellation Options</Link></li>
              <li><Link to="/covid" className="hover:text-primary">Our COVID-19 Response</Link></li>
            </ul>
          </div>

          {/* Empty for alignment */}
          <div></div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-border pt-8 md:flex-row">
          <p className="text-sm text-muted-foreground">
            © 2025 WanderDaddy Inc. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-muted-foreground">
            <Link to="/privacy" className="hover:text-primary">Privacy</Link>
            <Link to="/terms" className="hover:text-primary">Terms</Link>
            <Link to="/sitemap" className="hover:text-primary">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
